import { appAxiosAuthInstance } from '@/config/axios';
import { getStructuredLoginResponse } from '@/models/auth';
import { getStructuredRegisterResponse } from '@/models/auth/auth';

import {
	IGenerateOTPPayload,
	IGenerateOTPResponse,
	ILoginPayload,
	ILoginResponse,
	IRegisterPayload,
	IRegisterResponse,
} from './auth.types';

export async function generateOTP(payload: IGenerateOTPPayload) {
	const res = await appAxiosAuthInstance.post('/login/generate-otp', payload);

	const data = res.data as IGenerateOTPResponse;

	return data;
}

export async function login(payload: ILoginPayload) {
	let timeZone: string | undefined;
	try {
		timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	} catch {
		timeZone = undefined;
	}

	const payloadWithTimeZone = timeZone ? { ...payload, time_zone: timeZone } : payload;

	const res = await appAxiosAuthInstance.post('/login/', payloadWithTimeZone, {
		headers: {
			Ref: window.location.hostname,
			'X-Current-Domain': window.location.hostname,
		},
	});

	const data = res.data as ILoginResponse;

	const dataToReturn = getStructuredLoginResponse(data);

	// Return a response
	return dataToReturn;
}

export async function register(payload: IRegisterPayload) {
	const time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone;

	const res = await appAxiosAuthInstance.post('/login/register', payload, {
		headers: {
			Ref: window.location.hostname,
			'X-Current-Domain': window.location.hostname,
			'X-Timezone': time_zone,
		},
	});

	const data = res.data as IRegisterResponse;

	return getStructuredRegisterResponse(data);
}

export async function updateBannerShown() {
	const res = await appAxiosAuthInstance.post('/user/update-banner-shown');
	return res.data;
}
